import { Box, FormControl, FormLabel, TextField } from "@mui/material";
import { eachDeep } from 'deepdash-es/standalone';
import { cloneDeep, debounce } from 'lodash';
import React, { useCallback, useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector,useDispatch } from "react-redux";
import { ParentScreenCtx } from "../../../pages/workbench_build/WorkbenchBuild";
import { treeActions } from "../../../redux/slices/treeSlice";

function OutboundVariableCollectionDescription() {
  const { t } = useTranslation();
  
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
  const selectedNode = useSelector((state) => state.treeData[parentScreen].rightTree.tree.body.selectedNode)
  
  const dispatch = useDispatch()
  
  const [VCDescription, setVCDescription] = useState("");
  
  const submitChange = (key, val) => {
    if (key !== "DESCRIPTION") return;
    const updatedData = eachDeep(cloneDeep(translatedData), (objValue) => {
      if (objValue?.key !== selectedNode.key) {
        return;
      }
      if (key === "DESCRIPTION") {
        objValue[key] = val;
      }
      dispatch(
        treeActions.setRightTreeSelectedNode({
          screen: parentScreen,
          type: rightTree.currentTab,
          data: objValue,
        })
      );
    });
    dispatch(
      treeActions.setNewRightTreeTranslatedData({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: updatedData,
      })
    );
  };
  const debounceChangeHandler = useCallback(debounce(submitChange, 500), [
    rightTree.currentTab,
    rightTree.tree,
  ]);
  useEffect(() => {
    if (selectedNode && selectedNode?.DESCRIPTION) setVCDescription(selectedNode?.DESCRIPTION);
}, [selectedNode.key])
  return (
    <>
      <div className="height-100 padding-12">
        <div className="height-100">
            <FormControl className="width-100" size="small">
              <FormLabel style={{fontWeight:'bold'}}>{selectedNode.NAME} {t("LBL_DESC")}</FormLabel>
              <TextField
                className="text-field-scroll width-100"
                autoFocus={true}
                multiline={true}
                minRows={10}
                size="medium"
                type="text"
                value={VCDescription}
                onChange={(e) => {
                  setVCDescription(e.target.value);
                  debounceChangeHandler("DESCRIPTION", e.target.value);
                }}
              />
            </FormControl>
        </div>
      </div>
    </>
  );
}

export default OutboundVariableCollectionDescription;
